import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MIQNAF_SUMMARY_RCPA_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const MiqnafRCPASummaryReport = lazy(() =>
  import('../../../screens/MiqnafRCPASummaryReport')
    .then(module => ({default: module.MiqnafRCPASummaryReport})));

const MiqnafRCPASummaryReportNavigation = [
  {
    path: ROUTE_MIQNAF_SUMMARY_RCPA_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MiqnafRCPASummaryReport />
      </Suspense>
    ),
  },
];

export default MiqnafRCPASummaryReportNavigation;
